import { Center, Stack, Text } from '@chakra-ui/react'
import type { FC } from 'react'

import impactColor from '@app/pages/strategies/components/nodes/simulator/impactColor'
import CardSection from '@app/shared/cards/components/cardSection'
import { useStore } from '@app/store'
import type { CardSize, DomainMetric, DomainNode } from '@app/types'
import { formatStat, formatTotal } from '@app/utils/metricHelpers'
import { DisplayFormatEnum } from '@graphql/queries'

type Props = {
  node: Pick<DomainNode, 'simImpacts'>
  size: CardSize
}

const SimImpactsSection: FC<Props> = ({ node, size }) => {
  const simImpacts = node?.simImpacts
  const getNodeById = useStore.use.getNodeById()

  if (!simImpacts || simImpacts.length === 0) {
    return null
  }

  return (
    <CardSection size={size}>
      <Center>
        <Stack>
          {simImpacts.map((simImpact) => {
            const { name, nodeRfId, deltaR, percentR } = simImpact
            const root = getNodeById(nodeRfId)
            const rootMetric: DomainMetric = root?.data
            const color = impactColor(deltaR)

            return (
              <Text color={`${color}.700`} bgColor={`${color}.subtle`} key={nodeRfId} fontSize="lg" px={2} py={1}>
                {name} impact: {deltaR >= 0 ? '+' : ''}
                {formatTotal(deltaR, rootMetric?.displayFormat || DisplayFormatEnum.Number, rootMetric)}{' '}
                {typeof percentR === 'number' && (
                  <>
                    ({percentR >= 0 ? '+' : ''}
                    {formatStat(percentR, { maximumDisplayPrecision: 2 })}%)
                  </>
                )}
              </Text>
            )
          })}
        </Stack>
      </Center>
    </CardSection>
  )
}

SimImpactsSection.displayName = 'SimImpactsSection'

export default SimImpactsSection
